module.exports = __webpack_public_path__ + "static/Yuii@2x.8e4e138b.png";